<template>
  <b-sidebar
    :visible='visible'
    @change='onUpdateVisible'
    id='sidebar-backdrop'
    :title='title'
    backdrop-variant='dark'
    right
    backdrop
    shadow
    no-close-on-backdrop
  >
    <div class='px-3 py-2'>
      <slot></slot>
    </div>
  </b-sidebar>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    onUpdateVisible(val) {
      this.visible = val
    },
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
